import { EditSquareIcon } from "../../../../../assets/icons";
import TextArea from "../../../../../components/TextArea";
import Button from "../../../../../components/Button";
import Modal from "../../../../../components/Modal";
import styles from './style.module.scss';
import { useState } from "react";

interface Props {
    addFunc: (q: string) => void;
    closeFunc: () => void;
};

export default function AddNewInterviewQuestion(props: Props) {
    const { addFunc, closeFunc } = props;
    const [question, setQuestion] = useState('');

    return (
        <Modal
            size='md'
            title='Add new question'
            icon={<EditSquareIcon />}
            childClassName={styles.wrapper}
            closeFunc={closeFunc}
        >
            <span className={styles.label}>
                Write the question you would like to be asked:
            </span>
            <TextArea
                maxLength={200}
                value={question}
                onChange={setQuestion}
            />
            <div className={styles.actions}>
                <Button
                    type='Outline-Primary'
                    text='Cancel'
                    className={styles.actions_btn}
                    onClick={closeFunc}
                />
                <Button
                    type='Primary'
                    text='Add'
                    disabled={!question.trim()}
                    className={styles.actions_btn}
                    onClick={() => addFunc(question)}
                />
            </div>
        </Modal>
    )
};
